import React from 'react'
import { Link } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'
import Moment from 'react-moment'
import Loader from '../../common/Loader'
import ContractFileAdd from './addFile'

import Constant from '../../Constant'
import Swal from 'sweetalert2'
import axios from 'axios'

class ContractFiles extends React.Component {
  state = {
    isLoaded: true,
    isDeleting: false,

    type: 'C',
    type_id: '',

    list: [],
  }

  componentDidMount() {
    this.setState(
      {
        type_id: this.props.match.params.type_id,
        type: this.props.match.params.type,
      },
      () => {
        this.loadFiles()
      }
    )
  }

  loadFiles = async () => {
    this.setState({
      isLoaded: false,
    })

    await axios
      .get(Constant.getAPI() + '/admin/get-contract-files', {
        params: {
          reference_id: this.state.type_id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoaded: true,
        })
      })
  }

  downloadFile = (url) => {
    try {
      let name = url.split('/')[url.split('/').length - 1]

      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.download = name

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading the file', error)
    }
  }

  deleteFile = async (id) => {
    this.setState({
      isDeleting: true,
    })

    await axios
      .delete(Constant.getAPI() + '/admin/contract-file', {
        params: { id },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.loadFiles()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        })
      })
  }

  render() {
    const columns = [
      {
        name: 'name',
        label: 'Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ width: 100 }}>{value}</div> : '--'),
        },
      },
      {
        name: 'file',
        label: 'File',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? (
              <button
                className="btn btn-link"
                style={{ padding: 0 }}
                onClick={() => {
                  this.downloadFile(value)
                }}
              >
                {value.split('/')[value.split('/').length - 1]}
              </button>
            ) : (
              '--'
            ),
        },
      },
      // {
      //   name: 'created_by',
      //   label: 'Created By',
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
      //   },
      // },
      {
        name: 'created_at',
        label: 'Creation Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <div>
                <Moment format="YYYY-MM-DD hh:mm A">{value}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <div>
                <i
                  className="f-20 icofont icofont-trash text-danger"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.deleteFile(value)
                  }}
                ></i>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      selectableRows: 'none',
      sorting: false,

      textLabels: {
        body: {
          noMatch: !this.state.isLoaded ? <Loader open={!this.state.isLoaded} /> : 'Sorry, No Files Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <Loader
          fullPage={true}
          open={this.state.isDeleting}
        />
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div
                        className="d-inline"
                        style={{ width: 300 }}
                      >
                        <h4>Contract Files</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Contract files</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <ContractFileAdd
                type={this.state.type}
                type_id={this.state.type_id}
              ></ContractFileAdd>

              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          className="table-responsive"
                          data={this.state.list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ContractFiles
